import React, {useEffect, useState} from "react";
import { Container, Row, Col } from "react-bootstrap";
import $ from "jquery";
import Slider from 'react-slick';
import Cookies from 'universal-cookie'

import {
    isMobile, isMobileOnly
    // browserName
  } from "react-device-detect";

import { Link } from "@StarberryUtils";

import { getPropertyLink, getLettingsPriceQualifier } from '../../utils';
import { ShowProcessedImage } from '../common/ggfx-client/module/components/show-image';
import imageConfig from "../../../static/images/config.json"
import SaveProperty from "../property-search/saveProperty";
import FloorPlanModal from "../property-search/floorPlanModal";
import VideoPlay from "../Play/property-results-video";
import GetRegister from "./GetRegister/GetRegister"

import SearchResultsPagination from "./SearchResultsPagination";

import ComingSoonImage from "../../images/coming-soon.jpg"

var getstart = 0

const mycookies = new Cookies();
const updateAfter = 500

const InfiniteHits = ({
    algoliadata,
    hasPrevious,
    refinePrevious,
    hasMore,
    refineNext,
    location,
    page_url_data,
    userObjects
}) => (

    <>

        {/* <>
          {(algoliadata?.hits.length > 0 && hasPrevious) && (
              <button
                  id="myprevbut"
                  onClick={refinePrevious}
                  disabled={!hasPrevious}
                  className="d-none property_show_more_btn"
              >
                  Show prev
              </button>
          )}
        </> */}

        {
            algoliadata?.hits?.length > 0 && algoliadata?.hits.map((hit, i) => {

                const settings = {
                  dots: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  infinite: false,
                  arrows: true,
                  mobileFirst:true,
                  
                  responsive: [
                    {
                      breakpoint: 767,
                      settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1,
                              infinite: false,
                              dots: false,
                              arrows: true,
                          }
                    },
                    {
                        breakpoint: 9999,
                        settings: "unslick"
                    }
                  ]
                }

                // property details url structure
                let uriStr = "";

                if(hit.search_type === "sales" && hit.department === "residential" ) {
                  uriStr = `property-for-sale/`
                } else if(hit.search_type === "lettings" && hit.department === "residential" ) {
                  uriStr = `property-to-rent/`
                } else if(hit.search_type === "sales" && hit.department === "commercial" ) {
                  uriStr = `commercial-property-for-sale/`
                } else if(hit.search_type === "lettings" && hit.department === "commercial" ) {
                  uriStr = `commercial-property-to-rent/`
                } else if(hit.search_type === "sales" && hit.department === "new_developments" ) {
                  uriStr = `new-homes-for-sale/`
                }
                // property details url structure
                let propertyUrl = getPropertyLink(uriStr, hit);
                let priceQualifier = getLettingsPriceQualifier(hit);

                //property description
                let text_truncate = function(str, length, ending) {
                  //
                  var $win = $(window);

                  if ( $win.width() <= 1500 ) {
                      if (length == null) {
                          length = 100;
                      }
                  } else if ( $win.width() >= 1500 ) {
                      if (length == null) {
                          length = 220;
                      }
                  }
                  //

                  if (ending == null) {
                    ending = '...';
                  }
                  if (str.length > length) {
                    return str.substring(0, length - ending.length) + ending;
                  } else {
                    return str;
                  }
                };

                if(i == 0) {
                  getstart = 0
                }
                if(((i + 1) % 6) === 0) {
                  if(getstart >= 4) {
                    getstart = 0
                  }
                  getstart = getstart + 1
                }


                // property description
                return (
                  // <InView {...inViewOptions}>
                  //   {({ ref, inView }) => (
                      <>
                      {
                        // <motion.div
                        //   className="property-card d-md-flex flex-wrap mysingleproperty position-relative"
                        //   id={`mySaleProp${hit.objectID}`} key={i}
                        //   data-objectid={hit.objectID} data-lat={hit?._geoloc?.lat} data-lng={hit?._geoloc?.lng}
                        //   ref={ref}
                        //   initial="hidden"
                        //   animate={inView ? "visible" : "hidden"}
                        //   variants={containerItem}
                        // >
                        <div className="property-card d-md-flex flex-wrap mysingleproperty position-relative"
                          id={`mySaleProp${hit.objectID}`} key={i}
                          data-objectid={hit.objectID} data-lat={hit?._geoloc?.lat} data-lng={hit?._geoloc?.lng}
                          // ref={ref}
                        >
                          { (hit.status == "Sold" || hit.status == "Let" || hit.status == "Under Offer") &&
                            <div class="position-absolute text-white my-2 property-flag">{hit.status  == "Under Offer" ? `SOLD STC` : hit.status}</div>
                          }
                          <div className="view-part1" id={"pro_div_res"+hit.objectID}>
                            <Slider className="main-slider" {...settings} >
                                <div className="main-item">
                                    <Link onClick={() => {mycookies.set('mySaleProp', hit.objectID, { path: '/', maxAge: 300 });sessionStorage.setItem('searchindex', hit.objectID);}}
                                    to={propertyUrl}
                                    propID={hit.objectID}
                                    state={{ referrer: location.pathname }}>
                                      {
                                        hit.images1 ? <ShowProcessedImage images={hit.images1[0]} attr={{ className: 'mb-0 img-fluid', alt: ''}} transforms={imageConfig.property.searchResults1.sizes} />
                                        :
                                        <img loading="lazy" src={ComingSoonImage} alt="Martyn Gerrard" />
                                      }
                                    </Link>
                                    { (isMobile) &&
                                          <>
                                          {(hit.virtual_tour ? ((hit.virtual_tour.length > 0) ? <VideoPlay url={hit.virtual_tour}/> : ''):'')}
                                          </>
                                        }
                                    <div className="on-map d-flex">
                                        <Link onClick={() => {mycookies.set('mySaleProp', hit.objectID, { path: '/', maxAge: 300 });sessionStorage.setItem('searchindex', hit.objectID);}}
                                        to={`${propertyUrl}?id=propertymap` }><i className="icon-location"></i> <span className="exp-txt text-uppercase d-md-block d-none">View on Map</span></Link>
                                        {hit.floorplan && JSON.stringify(hit.floorplan) !== '{}' ? <FloorPlanModal floorplanimg={hit.floorplan.url} /> : ''}
                                    </div>
                                </div>
                                <div className="main-item d-md-none">
                                    <Link onClick={() => {mycookies.set('mySaleProp', hit.objectID, { path: '/', maxAge: 300 });sessionStorage.setItem('searchindex', hit.objectID);}}
                                    to={propertyUrl}
                                    propID={hit.objectID}
                                    state={{ referrer: location.pathname }}>
                                      {
                                        hit.images2 && hit.images2.length > 0 ? <ShowProcessedImage images={hit.images2[0]} attr={{ className: 'mb-0 img-fluid', alt: ''}} transforms={imageConfig.property.searchResults2.sizes} />
                                        :
                                        <img loading="lazy" src={ComingSoonImage} alt="Martyn Gerrard" />
                                      }
                                    </Link>
                                    {/* <Link className="play-btn" to="#"><i className="icon-play-icon"></i></Link> */}
                                </div>
                                <div className="main-item d-md-none">
                                    <Link onClick={() => {mycookies.set('mySaleProp', hit.objectID, { path: '/', maxAge: 300 });sessionStorage.setItem('searchindex', hit.objectID);}}
                                    to={propertyUrl}
                                    propID={hit.objectID}
                                    state={{ referrer: location.pathname }}>
                                      {
                                        hit.images2 && hit.images2.length > 0 ? <ShowProcessedImage images={hit.images2[1]} attr={{ className: 'mb-0 img-fluid', alt: ''}} transforms={imageConfig.property.searchResults2.sizes} />
                                        :
                                        <img loading="lazy" src={ComingSoonImage} alt="Martyn Gerrard" />
                                      }
                                    </Link>
                                </div>
                            </Slider>
                          </div>
                          <div className="view-part2 d-none d-md-block" id={"pro_div_res"+hit.objectID}>
                            <div className="main-item">
                                <Link onClick={() => {mycookies.set('mySaleProp', hit.objectID, { path: '/', maxAge: 300 });sessionStorage.setItem('searchindex', hit.objectID);}}
                                to={propertyUrl}
                                propID={hit.objectID}
                                state={{ referrer: location.pathname }}>
                                  {
                                    hit.images2 && hit.images2.length > 0 ? <ShowProcessedImage images={hit.images2[0]} attr={{ className: 'mb-0 img-fluid', alt: ''}} transforms={imageConfig.property.searchResults2.sizes} />
                                    :
                                    <img loading="lazy" src={ComingSoonImage} alt="Martyn Gerrard" />
                                  }
                                </Link>
                                {/* <Link className="play-btn" to="#"><i className="icon-play-icon"></i></Link> */}
                                {(hit.virtual_tour ? ((hit.virtual_tour.length > 0) ? <VideoPlay url={hit.virtual_tour}/> : ''):'')}
                            </div>
                            <div className="main-item">
                                <Link onClick={() => {mycookies.set('mySaleProp', hit.objectID, { path: '/', maxAge: 300 });sessionStorage.setItem('searchindex', hit.objectID);}}
                                to={propertyUrl}
                                propID={hit.objectID}
                                state={{ referrer: location.pathname }}>
                                  {
                                    hit.images2 && hit.images2.length > 0 ? <ShowProcessedImage images={hit.images2[1]} attr={{ className: 'mb-0 img-fluid', alt: ''}} transforms={imageConfig.property.searchResults2.sizes} />
                                    :
                                    <img loading="lazy" src={ComingSoonImage} alt="Martyn Gerrard" />
                                  }
                                </Link>
                            </div>
                          </div>
                          <Link onClick={() => {mycookies.set('mySaleProp', hit.objectID, { path: '/', maxAge: 300 });sessionStorage.setItem('searchindex', hit.objectID);}}
                            to={propertyUrl}
                            className="card-details d-flex align-items-center"
                            propID={hit.objectID}
                            state={{ referrer: location.pathname }}
                          >
                            <div className="w-100">
                              <div className="detail-head d-flex align-items-center justify-content-between">
                                <div className="sec-title price-title">
                                  {
                                    hit.price_qualifier === "POA" ? hit.price_qualifier : (hit.price ? <><span className="price_qua_price">&pound;{hit.price.toLocaleString()}</span>{priceQualifier ? <> <span className="price_qualifier">{priceQualifier}</span></> : ''}</> : '')
                                  }
                                </div>
                                  {/* { hit.price ? <h2 className="price">&pound;{hit.price.toLocaleString()}</h2> : '' } */}
                                  {/* <SaveProperty type="property" pid={hit.objectID} userObjects={userObjects}/> */}
                              </div>
                              <span className="address-title d-block">
                                { hit.display_address ? hit.display_address : '' }
                              </span>
                              { hit.title ? <span className="prop-title d-block">{hit.title}</span> : '' }
                              { hit.description ? <p className="prop-desc d-none d-md-block mb-0">{text_truncate(hit.description)}</p> : '' }
                            </div>
                          </Link>
                          <SaveProperty type="property" pid={hit.objectID} userObjects={userObjects}/>
                        {/* </motion.div> */}
                        </div>
                      }

                      {
                        ((i + 1) % 6) === 0 ?
                        <GetRegister getstart={getstart}/>
                        : ''
                      }
                      </>
                  //   )}
                  // </InView>
                )
            })
        }

        {/* ======= Pagination ============ */
            (algoliadata?.hits?.length > 0 && (algoliadata?.total > algoliadata?.hitsPerPage) ? 
                <Container className="px-3">
                    <Row>
                        <Col lg={12} className="text-center load-more-btn px-0">
                            <SearchResultsPagination location_path={location?.pathname} page_url_data={page_url_data} total={algoliadata?.total} current_page_number={algoliadata?.current_page_number} hitsPerPage={algoliadata?.hitsPerPage} nbPages={algoliadata?.number_of_pages} />
                        </Col>
                    </Row>
                </Container>
                : <div className="empty-space-search"></div>
            )
        }


        {/* {(algoliadata?.hits.length > 0 && hasMore) && (
        <Container className="px-3">
          <Row>
            <Col lg={12} className="text-center load-more-btn px-0">
              {(algoliadata?.hits.length > 0 && hasMore) && (
              <button
                  id="mynextbut"
                  onClick={refineNext}
                  disabled={!hasMore}
                  className="btn w-100 loadMoreBtn"
              >
                  Load more
              </button>
              )}
            </Col>
          </Row>
        </Container>
        )} */}

    </>
)

export default InfiniteHits